import { Box, Text } from "@chakra-ui/react";

export interface CollapseItemProps {
   cookieName: string;
   duration: string;
   description: string;
}

const CollapseItem = ({
   cookieName,
   duration,
   description,
}: CollapseItemProps) => {
   return (
      <Box
         display="grid"
         gridTemplateColumns="100px 1fr"
         fontSize={14}
         gap=".5rem"
      >
         <Text fontWeight={700}>Cookie</Text>
         <Text>{cookieName}</Text>
         <Text fontWeight={700}>Duration</Text>
         <Text>{duration}</Text>
         <Text fontWeight={700}>Description</Text>
         <Text>{description}</Text>
      </Box>
   );
};

export default CollapseItem;
